import React from 'react'

// この hook は安全ではありません。
// React.StrictModeが有効なとき、コンポーネントが２回マウントされます。
// このとき コントラクタや useEffect などで指定した関数も２回呼ばれることになりますが、
// 一部では２回呼ぶことでエラーが発生する関数もあります。
// それを回避するためだけに使用します。
// 使用する際はできるだけ適用範囲を小さくし、
// 必ず 'なぜ使用しなければならないか' をコメントとして残すようにしてください。
export function useUnsafeOnceCall() {
  const onceFlag = React.useRef(false)
  return (action: VoidFunction) => {
    if (onceFlag.current) return
    onceFlag.current = true
    action()
  }
}
